import './card';
import { Lit3formBlock, html } from '@Root/lib/lit-3form-block';

import { fetchCart, addToCart } from '@Root/spree/api';
import {
  updateCartIndicator,
  changeProductNameInModal,
  changeProductImageInModal,
} from '@Root/spree/dom';
import {
  useCartConfirmationModal,
  logErrorToSentry,
} from '../../../helpers/helpers';

import '@Root/lib/lit-3form-block/components/cta-button';

import { styles } from './css';
export class DirectProductIndex extends Lit3formBlock {
  static get characterName() {
    return 'direct-product-index';
  }

  static get characterStyles() {
    return [...styles];
  }

  static properties = {
    _searchInput: { type: String },
    _filteredProductsList: { type: Array },
  };

  constructor() {
    super();
    this._searchInput = '';
    this._filteredProductsList = this.productsList;

    this.addEventListener('addToCart', async e => {
      await this.addToCart(e.detail.product, e.detail.quantity);
    });
  }

  async connectedCallback() {
    super.connectedCallback();

    try {
      await this.setupSpreeData();
    } catch (error) {
      logErrorToSentry(error);
    }
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid direct-product-layout">
          ${this.headerHtml} ${this.productsListHtml}
        </div>
      </div>
    `;
  }

  get headerHtml() {
    return html`
      <div class="header">
        <h3>Products</h3>
        <span class="search-input">
          <form method="get" action="/search">
            <input
              type="text"
              placeholder="Search by Name"
              id="search-input"
              name="search-input"
              .value="${this._searchInput || ''}"
              @input="${this.onSearchInputChange}"
            />
            <img src="/static/icons/SVG/search.svg" />
          </form>
        </span>
      </div>
    `;
  }

  get productsListHtml() {
    return html`
      <div class="products-list">
        ${this._filteredProductsList.length
          ? this.filteredProductsListHtml
          : this.noProductsHtml}
      </div>
    `;
  }

  get filteredProductsListHtml() {
    return this._filteredProductsList.map(
      product => html`
        <direct-product-index-card .product="${product}">
        </direct-product-index-card>
      `
    );
  }

  get noProductsHtml() {
    return html`
      <div class="no-results-message">
        <p>
          No products found. Contact your project manager if this is an error.
        </p>
      </div>
    `;
  }

  onSearchInputChange(e) {
    this._searchInput = e?.target?.value;
    this._filteredProductsList = this.productsList.filter(product =>
      product.name.toLowerCase().includes(this._searchInput.toLowerCase())
    );
  }

  optionalDetailRow(property, propertyName) {
    if (!property || !propertyName) return html``;
    return html`
      <div class="optional-row-wrapper">
        <span class="optional-row-header">${propertyName}</span>
        <span class="optional-row-value">${property}</span>
      </div>
    `;
  }

  productModalImageUrl(url) {
    return this.imagebossUrl(url, null, '200');
  }

  get productsList() {
    return this.content.direct_products || [];
  }

  async setupSpreeData() {
    if (!this.cart) {
      this.cart = await fetchCart();
      if (this.cart) updateCartIndicator(this.cart.data.attributes.item_count);
    }

    this.requestUpdate();
  }

  async addToCart(product, quantity) {
    useCartConfirmationModal();

    const variantId = product.spree_product.variant_id,
      imageUrl = product.image_url,
      name = product.name;

    this.cart = await addToCart(variantId, quantity);
    if (this.cart) {
      changeProductNameInModal(name, '');
      changeProductImageInModal(this.productModalImageUrl(imageUrl));
      updateCartIndicator(this.cart.item_count);
    }
  }
}
DirectProductIndex.defineElement();
